import { render, staticRenderFns } from "./AddArticles.vue?vue&type=template&id=366d48ee&scoped=true&"
import script from "./AddArticles.vue?vue&type=script&lang=js&"
export * from "./AddArticles.vue?vue&type=script&lang=js&"
import style0 from "./AddArticles.vue?vue&type=style&index=0&id=366d48ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366d48ee",
  null
  
)

export default component.exports